import { cryptoKeyToBase64, encryptCryptoKeyWithPublicKey, generateCryptoPairs, } from '@lucidlink/ts-crypto/crypto';
import { webCrypto } from '@lucidlink/ts-crypto/web-crypto';
import { signWorkspaceCryptoTuple } from '#sdk/workspace-client/crypto/crypto-utils';
export const prepareMemberCommon = async ({ workspaceId, invitationKeys, }) => {
    const principalId = webCrypto.randomUUID();
    const { memberKeys, storedCrypto } = await prepareMemberCrypto({ workspaceId, invitationKeys }, principalId);
    return {
        member: {
            principalId,
            ...storedCrypto,
        },
        memberKeys,
    };
};
export const prepareMemberCrypto = async ({ workspaceId, invitationKeys }, principalId) => {
    const memberKeys = await generateCryptoPairs();
    const memberPublicKeyPromise = cryptoKeyToBase64(memberKeys.encryptPair.publicKey);
    const ePrivateKeyByInvitationKeyPromise = encryptCryptoKeyWithPublicKey(memberKeys.encryptPair.privateKey, invitationKeys.encryptPair.publicKey);
    const eInvitationPrivateKeyByMemberKeyPromise = encryptCryptoKeyWithPublicKey(invitationKeys.encryptPair.privateKey, memberKeys.encryptPair.publicKey);
    const sMemberByInvitationKeyPromise = signWorkspaceCryptoTuple({
        id: principalId,
        workspaceId,
        publicKey: memberKeys.encryptPair.publicKey,
    }, invitationKeys.signPair.privateKey);
    return {
        storedCrypto: {
            publicKey: await memberPublicKeyPromise,
            ePrivateKeyByInvitationKey: await ePrivateKeyByInvitationKeyPromise,
            eInvitationPrivateKeyByMemberKey: await eInvitationPrivateKeyByMemberKeyPromise,
            sMemberByInvitationKey: await sMemberByInvitationKeyPromise,
        },
        memberKeys,
    };
};
export const prepareMemberCryptoArray = async (memberPrincipals) => {
    return Promise.all(memberPrincipals.map(async ({ workspaceId, invitationKeys, principalId }) => {
        const { storedCrypto } = await prepareMemberCrypto({ workspaceId, invitationKeys }, principalId);
        return { ...storedCrypto, principalId };
    }));
};
